import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import FullScreenErrorDialog from '../FullScreenErrorDialog/FullScreenErrorDialog';

function ErrorBoundaryFallback() {
  const routeError = useRouteError() as Error;

  useEffect(() => {
    captureException(routeError, { level: 'fatal' });
  }, [routeError]);

  return <FullScreenErrorDialog dialogErrorMsg={routeError?.message} />;
}

ErrorBoundaryFallback.propTypes = {};

export default ErrorBoundaryFallback;
